<template>
  <div class="side">
    <router-link :to="'/product/ticket'">票务系统</router-link>
    <div class="split"></div>
    <router-link :to="'/product/ops'">运维服务</router-link>
    <div class="split"></div>
    <router-link :to="'/product/commService'">社会化服务</router-link>
    <div class="split"></div>
    <router-link :to="'/product/hardware'">硬件产品</router-link>
    <div class="split"></div>
    <router-link :to="'/product/consulting'">咨询服务</router-link>
    <div class="split"></div>
    <router-link :to="'/product/bigdata'">大数据监控</router-link>
    <!-- <router-link :to="'/product/distribution'">分销平台</router-link>
      <router-link :to="'/product/passengerFlow'">域内流量统计</router-link> -->
  </div>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.side {
  min-width: 140px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  list-style-type: none;
  line-height: 40px;

  > a {
    // padding: 10px 47px;
    font-size: 22px;
    font-weight: bold;
    color: #666666;
    line-height: 35px;
    text-decoration: none;
    cursor: pointer;
    // border-right: 1px solid #eeeeee;

    &:last-child {
      border-right-width: 0;
    }

    &:hover,
    &:focus {
      color: #145a84;
    }

    &.router-link-active {
      color: #145a84;
    }
  }

  > .split {
    width: 1px;
    height: 50px;
    margin: 20px 0;
    background-color: #eeeeee;
  }
}
</style>